import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { AppRoutingService, SessionService } from '@ui-components/services';
import { AppService } from '@ui-components/services';
import { IProfile, IResponse } from '@interfaces/index';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '@environments/environment';
import { ConsentService, startMonitoring } from '@ui-components/consent';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'assessments';
  profile: IProfile | null = null;

  get loading() {
    return this._app_service.loading;
  }

  constructor(
    protected _app_routing_service: AppRoutingService,
    protected _app_service: AppService,
    protected _cookie_service: CookieService,
    protected _session_service: SessionService,
    consent: ConsentService,
    ngZone: NgZone
  ) {
    consent.choice$.subscribe(choice => {
      if (choice === 'granted') {
        startMonitoring(environment.new_relic.assessments.applicationId, ngZone);
      }
    });
  }

  ngOnInit() {
    const token = this._cookie_service.get('access_token');
    if (token) {
      this._session_service.startIdleWatch();
      this._app_service.getProfile().subscribe(
        (response: IResponse<IProfile>) => {
          this.profile = response.data;
          this._app_service.loading = false;
        }
      )
    } else {
      this._app_service.loading = false;
    }
  }

  ngOnDestroy(): void {
    this._session_service.stopIdleWatch();
  }

  goToOllie() {
    this._app_routing_service.goToOllie()
  }

  updateScroll(scroll_event: any) {
    if (scroll_event.target) {
      this._app_service.on_scroll.next(scroll_event.target.scrollTop)
    }
  }
}
